// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__64SNe","dragIcon":"Choice_dragIcon__2nxOb","left":"Choice_left__5EIy-","input":"Choice_input__3oW7w"};